export function isNotChromeBrowser() {
  const { userAgent } = navigator;
  return !/Chrome/.test(userAgent);
}
